export default "__VITE_ASSET__DViJEs59__"